
import {
  Vue,
  Component,
} from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import { IImage } from '@/common/interface';

@Component({})
export default class VideoUploadModal extends Vue {
  val: IImage = {
    id: 0,
    url: '',
  };

  uploading = false;

  visible = false;

  BASE_URL = BASE_URL;

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/album/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  token: string | undefined = undefined;

  videoList: any[] = [];

  @lazyInject(UserService)
  protected userService!: UserService;

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      console.log(data);
      const result: any = {
        resource_id: data[0]?.id,
        url: data[0]?.url,
        path: data[0]?.url,
        resource_no: data[0]?.code,
        cover: data[0]?.cover,
        title: '视频封面',
      };
      console.log(result);
      this.videoList.push(result);
      this.uploading = false;
    }
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  init(val: any) {
    this.videoList = JSON.parse(JSON.stringify(val));
    this.visible = true;
  }

  deleteImage(ev: Event, index: number) {
    // eslint-disable-next-line no-param-reassign
    ev.cancelBubble = true;
    this.videoList.splice(index, 1);
  }


  handleCancel() {
    this.visible = false;
  }
  handleOk() {
    this.visible = false;
    console.log('点击确定');
    this.$emit('changeVideo', this.videoList);
  }
}
